import { render, staticRenderFns } from "./change-market.vue?vue&type=template&id=2a3befa6&scoped=true&"
import script from "./change-market.vue?vue&type=script&lang=js&"
export * from "./change-market.vue?vue&type=script&lang=js&"
import style0 from "./change-market.vue?vue&type=style&index=0&id=2a3befa6&scoped=true&lang=css&"
import style1 from "./change-market.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3befa6",
  null
  
)

export default component.exports